import { z } from 'zod'

import { pagedSchema } from '../core'

const text = z.string().nullish()

/** A user as the backend sends it. `roles` holds ADMIN, DESIGNER, EDITOR, REVIEWER and APPROVER. */
export const userSchema = z.object({
  id: z.string(),
  accountId: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phoneNumber: text,
  roles: z.array(z.string()).default([]),
  isActive: z.boolean().default(true),
  createdBy: text,
  createdAt: z.string(),
  updatedAt: text,
})
export type UserDto = z.infer<typeof userSchema>

export const userPageSchema = pagedSchema(userSchema)

/** POST /api/v1/users */
export interface UserCreateBody {
  accountId: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  roles: string[]
  createdBy: string
}

/** PUT /api/v1/users/{id}: the whole record is sent, so pass what stays the same too. */
export interface UserUpdateBody {
  accountId: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  roles: string[]
  isActive: boolean
}

/** Query-string filters of GET /api/v1/users. `search` matches name or email, any case, partial. */
export interface UserFilters {
  accountId?: string
  role?: string
  isActive?: boolean
  search?: string
}
